export default __webpack_public_path__ + "static/media/warning.7c03b579.svg";